// Module
var code = "<script id=\"wcc-components-wcc-select-2\" type=\"text/template\">\r\n    <select class=\"wcc-select-2__node\" data-templateresults=\"formatUserCard\" data-bind=\"dom: selectNode\"></select>\r\n</script>";
// Exports
module.exports = code;